import type { World } from "@cimara/world";
import { formatDistance, formatElapsed, formatPower } from "../lib/format";
import type { RideSummary } from "../ride/store";
import { CourseMap } from "./CourseMap";

interface ResultsScreenProps {
  world: World | null;
  summary: RideSummary;
  onRideAgain(): void;
  onHome(): void;
}

export function ResultsScreen({ world, summary, onRideAgain, onHome }: ResultsScreenProps) {
  return (
    <main className="results-screen">
      <div className="results-card">
        <div className="wordmark wordmark--small results-wordmark">
          <span className="wordmark__mark" />
          <span>CIMARA</span>
        </div>

        <p className="eyebrow">
          <span className="eyebrow__line" />
          Ride complete
        </p>
        <h1 className="results-title">Good work.</h1>
        <p className="results-sub">
          Free ride summary. Race results are persisted separately and appear in
          your history after the finish.
        </p>

        <dl className="results-stats">
          <div>
            <dt>Distance</dt>
            <dd>
              {formatDistance(summary.distanceM)}
              <span>km</span>
            </dd>
          </div>
          <div>
            <dt>Time</dt>
            <dd>{formatElapsed(summary.elapsedMs)}</dd>
          </div>
          <div>
            <dt>Avg power</dt>
            <dd>
              {formatPower(summary.averagePower)}
              <span>W</span>
            </dd>
          </div>
          <div>
            <dt>Laps</dt>
            <dd>{summary.laps}</dd>
          </div>
        </dl>

        <div className="results-lower">
          <CourseMap world={world} />
          <div className="results-meta">
            <span>World {summary.worldVersion}</span>
            <span>Server-authoritative</span>
            <span>Sim + trainer power</span>
          </div>
        </div>

        <div className="results-actions">
          <button type="button" className="ride-button ride-button--compact" onClick={onRideAgain}>
            <span>Ride again</span>
            <span className="ride-button__arrow" aria-hidden="true">
              →
            </span>
          </button>
          <button type="button" className="text-button" onClick={onHome}>
            Back to start
          </button>
        </div>
      </div>
    </main>
  );
}
